import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import { MENU_PROPS } from 'components/admin/CompanySelect'
import { sortBrokersBySurname } from 'config/helpers/Brokers'

/*
 * The "Assign to Broker" dropdown, shared by the in-lead modal and the bulk
 * allocate modal — previously two separate implementations, one unsorted and
 * one sorted by first name.
 *
 * Shows only brokers currently active for the selected company and product,
 * sorted by surname, in a menu anchored to its select. Everyone else is behind
 * the "Show all brokers" link.
 */

/*
 * getAllBrokers (libs/helper-lib.js) already strips @brokerdiary.io accounts and
 * hideInAnalytics brokers server-side; the remaining two signals for "no longer
 * taking leads for this product" are the broker's own product list and a zero
 * weekly allocation on the company record.
 */
export function isActiveBroker(broker, companyDetails, product) {
    if (!broker) return false
    if (broker.hideInAnalytics) return false

    if (broker.products && broker.products.length > 0
        && broker.products[0] !== 'All'
        && broker.products.indexOf(product) === -1) {
        return false
    }

    const allocations = companyDetails
        && companyDetails.allocations
        && companyDetails.allocations[product]
    if (allocations && Object.keys(allocations).length > 0) {
        const allocation = parseInt(allocations[broker.brokerId])
        if (!allocation || allocation <= 0) return false
    }

    return true
}

export default function BrokerSelect(props) {
    const { brokers = [], companyDetails, product, value, onChange } = props
    const [showAll, setShowAll] = useState(false)

    const active = brokers.filter((broker) => isActiveBroker(broker, companyDetails, product))
    const display = sortBrokersBySurname(showAll ? brokers : active)
    const hiddenCount = brokers.length - active.length

    return (
        <>
            <Select
                multiple={false}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                IconComponent={KeyboardArrowDown}
                MenuProps={MENU_PROPS}
            >
                <MenuItem value={'unassigned'}>Auto Assign</MenuItem>
                {display.map((broker) => (
                    <MenuItem key={broker.brokerId} value={broker.brokerId}>
                        {broker.firstName + ' ' + broker.lastName}
                    </MenuItem>
                ))}
            </Select>
            {hiddenCount > 0 &&
                <Box
                    component='span'
                    fontSize='12px'
                    color='primary.main'
                    style={{ cursor: 'pointer', marginTop: '4px', display: 'inline-block' }}
                    onClick={() => setShowAll(v => !v)}
                >
                    {showAll ? 'Show active brokers only' : `Show all brokers (${brokers.length})`}
                </Box>
            }
        </>
    )
}
